import { useParams } from '@thd-olt-component-react/router';
import { STYLE_REFINEMENTS, COLOR_REFINEMENTS, ROOM_REFINEMENTS } from './Constants';

export const usePathnameParams = () => {
  let { param1, param2, param3 } = useParams();
  let params = [param1, param2, param3];
  let roomParam = '';
  let styleParam = '';
  let colorParam = '';

  params.forEach((param) => {
    if (ROOM_REFINEMENTS.find((room) => (room === param))) {
      roomParam = param;
    } else if (STYLE_REFINEMENTS.find((style) => (style === param))) {
      styleParam = param;
    } else if (COLOR_REFINEMENTS.find((color) => (color === param))) {
      colorParam = param;
    }
  });

  return { roomParam, styleParam, colorParam };
};

export const constructURL = (
  styles = [], colors = [], rooms = [], page = 1
) => {
  let stylesRoute = '';
  let stylesUrlParams = '';
  let colorsRoute = '';
  let colorsUrlParams = '';
  let roomsRoute = '';
  let roomsUrlParams = '';
  let pageString = '';
  let ncniString = '';

  if (rooms.length > 0) {
    rooms.forEach((room) => {
      if (roomsRoute.length === 0) {
        roomsRoute = `/${room}`;
      } else if (roomsUrlParams.length === 0) {
        roomsUrlParams += `?room=${room}`;
      } else {
        roomsUrlParams += `%7C${room}`;
      }
    });
  }

  if (styles.length > 0) {
    styles.forEach((style) => {
      if (stylesRoute.length === 0) {
        stylesRoute = `/${style}`;
      } else if (stylesUrlParams.length === 0 && roomsUrlParams.length === 0) {
        stylesUrlParams += `?style=${style}`;
      } else if (stylesUrlParams.length === 0 && roomsUrlParams.length > 0) {
        stylesUrlParams += `&style=${style}`;
      } else {
        stylesUrlParams += `%7C${style}`;
      }
    });
  }

  if (colors.length > 0) {
    colors.forEach((color) => {
      if (colorsRoute.length === 0) {
        colorsRoute = `/${color}`;
      } else if (colorsUrlParams.length === 0 && (stylesUrlParams.length === 0 && roomsUrlParams.length === 0)) {
        colorsUrlParams += `?color=${color}`;
      } else if (colorsUrlParams.length === 0 && (stylesUrlParams.length > 0 || roomsUrlParams.length > 0)) {
        colorsUrlParams += `&color=${color}`;
      } else {
        colorsUrlParams += `%7C${color}`;
      }
    });
  }

  if ((roomsUrlParams.length > 0 || stylesUrlParams.length > 0 || colorsUrlParams.length > 0)) {
    pageString = `&Nao=${page}`;
    ncniString = '&NCNI-5';
  } else {
    pageString = `?Nao=${page}`;
  }

  // eslint-disable-next-line max-len
  const newUrl = `/room${roomsRoute}${stylesRoute}${colorsRoute}${roomsUrlParams}${stylesUrlParams}${colorsUrlParams}${pageString}${ncniString}`;
  return newUrl;
};

export const clearAndUpdateURL = (filter) => {
  let formattedFilter = filter[0].replace(' ', '-').toLowerCase();
  return formattedFilter;
};

export const capitalizeFirstLetter = (word) => word?.charAt(0).toUpperCase() + word?.slice(1);